export const config = {
  // Upload server configuration
  UPLOAD_SERVER_URL: process.env.REACT_APP_UPLOAD_SERVER_URL || 'http://localhost:3010',
}